<script setup lang="ts">
// PROPS
import { twMerge } from 'tailwind-merge';

const props = defineProps({
    class: { type: String, default: undefined },
});

// COMPOSABLES
const { tt } = useTypedI18n();
const { phones } = useFleequidContacts();

// DATA
const mergedClass = twMerge('bg-neutral-50 p-4', props.class);
</script>

<template>
    <div class="flex flex-1 flex-col items-start justify-between gap-4 rounded-xl text-left" :class="mergedClass">
        <div>
            <p class="text-xs font-extrabold uppercase">{{ tt('customerServiceContact.title') }}</p>
            <p class="text-toned text-sm leading-5">{{ tt('customerServiceContact.description') }}</p>
        </div>
        <div class="flex flex-wrap items-end gap-2 text-xs">
            <div v-for="phone in phones" :key="phone" class="flex gap-1">
                <UIcon name="lucide:phone" class="size-4" />
                <BasePhoneLink :phone="phone" type="customerService" />
            </div>
            <div class="flex gap-1">
                <UIcon name="lucide:mail" class="size-4 text-inherit" />
                <FleequidEmailLink type="customerService" />
            </div>
        </div>
    </div>
</template>
